export const GARAGES_GET_REQUEST = 'GARAGES_GET_REQUEST';
export const GARAGES_GET_SUCCESS = 'GARAGE_GET_SUCCESS';
export const GARAGES_GET_FAIL = 'GARAGES_GET_FAIL';
